<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择标签"
      width="800px"
      :close-on-click-modal="false"
      top="5vh">
    <vm-table ref="vmTable" :filter.sync="filter" module="basic" url="snMetaData">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="编号：">
            <el-input v-model.trim="filter.metaDataNo" placeholder="请输入编号"/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="metaDataNo" align="center" label="标签" width="80"/>
      <el-table-column prop="metaDataDesc" align="left" label="描述"/>
      <el-table-column label="操作" align="center" width="80px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "MaterialSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        idList: "",
        filter: {
          metaDataNo: "",
        },
      };
    },

    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
